import { values, pick, isNil } from 'lodash';
import { TreatmentDetails } from '../Types';
import useEditState from './useEditState';
import { getRelatedInquiry, toDate } from '../util';
import { useEffect } from 'react';

export const useEditTreatmentEpisodeState = (
  treatmentEpisode?: TreatmentEpisode,
  inquiry?: InquiryDetailResponse,
) => {
  const initialState: TreatmentDetails = treatmentEpisode
    ? {
        admitDate: toDate(treatmentEpisode.admitDate),
        dischargeDate: toDate(treatmentEpisode.closedDate),
        dischargeReason: treatmentEpisode.statusReason,
        level: treatmentEpisode.level,
        program: treatmentEpisode.treatmentProgramName,
        relatedInquiry: getRelatedInquiry(inquiry),
        statusDescription: treatmentEpisode.status?.description,
      }
    : {};
  const { reset, ...state } = useEditState<TreatmentDetails>(
    initialState,
    (data) =>
      values(pick(data, ['admitDate', 'statusDescription'])).some(isNil),
  );

  const resetState = (state?: TreatmentDetails) => {
    const treatmentEpisodeState: TreatmentDetails =
      state ||
      (treatmentEpisode
        ? {
            ...treatmentEpisode,
            admitDate: toDate(treatmentEpisode.admitDate),
            dischargeDate: toDate(treatmentEpisode.closedDate),
            dischargeReason: treatmentEpisode.statusReason,
            level: treatmentEpisode.level,
            program: treatmentEpisode.treatmentProgramName,
            relatedInquiry: getRelatedInquiry(inquiry),
            statusDescription: treatmentEpisode.status?.description,
          }
        : initialState);
    reset({
      ...treatmentEpisodeState,
    });
  };

  useEffect(() => {
    resetState();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [treatmentEpisode, inquiry]);

  return {
    resetState,
    ...state,
  };
};
